import { ErrorBoundary } from "react-error-boundary";
import { Outlet } from "react-router-dom";
import * as React from "react";
import Box from "@mui/material/Box";

import { AdminNavbar } from "../shared-components/sidebar/SideBar";

export default function AdminStickLayout(props: any): React.ReactElement {
  return (
    <Box sx={{ width: '100%', maxWidth: '100%', overflow: 'hidden', display: 'flex', minHeight: '100vh' }}>
      <AdminNavbar />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          minWidth: 0,
          minHeight: '100vh',
          pt: { xs: '64px', md: 3 },
          pl: { xs: 2, sm: 2.5, md: 3.5 },
          pr: { xs: 2, sm: 2.5, md: 3.5 },
          pb: { xs: 3, sm: 3.5, md: 4 },
          boxSizing: 'border-box',
          animation: 'pageFadeIn 0.35s ease-out',
        }}
      >
        <ErrorBoundary
          fallback={
            <Box sx={{ p: 4, border: '1px solid', borderColor: 'divider', borderRadius: 2, bgcolor: 'background.paper' }}>
              Something went wrong loading this page. Try refreshing.
            </Box>
          }
        >
          <Outlet />
        </ErrorBoundary>
      </Box>
    </Box>
  );
}
